import {
	faCircleInfo,
	faCircleQuestion,
	faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Tooltip,
	TooltipArrow,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface InfoIconProps {
	type?: 'question' | 'info' | 'warning';
	color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light';
	tooltipContent?: string;
	className?: string;
	testId?: string;
}

const colorClasses: Record<string, string> = {
	primary: 'text-primary',
	secondary: 'text-muted-foreground',
	success: 'text-green-600',
	danger: 'text-destructive',
	warning: 'text-yellow-600',
	info: 'text-blue-600',
	dark: 'text-foreground',
	light: 'text-muted-foreground'
};

const iconMap: Record<'question' | 'info' | 'warning', typeof faCircleQuestion> = {
	question: faCircleQuestion,
	info: faCircleInfo,
	warning: faTriangleExclamation
};

const InfoIcon = ({
	type = 'question',
	color = 'primary',
	tooltipContent = '',
	className = '',
	testId
}: InfoIconProps) => {
	const colorClass = colorClasses[color] || colorClasses.primary;
	const icon = iconMap[type];

	if (!tooltipContent) {
		return (
			<span className={cn('inline-flex items-center ml-2', className)}>
				<FontAwesomeIcon
					icon={icon}
					className={cn('text-sm', colorClass)}
					data-testid={testId || `info-icon-${type}`}
				/>
			</span>
		);
	}

	return (
		<span className={cn('inline-flex items-center ml-2', className)}>
			<TooltipProvider>
				<Tooltip>
					<TooltipTrigger asChild>
						<span>
							<FontAwesomeIcon
								icon={icon}
								className={cn('text-sm', colorClass)}
								data-testid={testId || `info-icon-${type}`}
							/>
						</span>
					</TooltipTrigger>
					<TooltipContent>
						<p>{tooltipContent}</p>
						<TooltipArrow />
					</TooltipContent>
				</Tooltip>
			</TooltipProvider>
		</span>
	);
};

export default InfoIcon;
